var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-product-modal",attrs:{"align":"right"}},[_c('b-modal',{attrs:{"id":"preview-capsule","size":"lg","lazy":true,"hide-footer":""}},[_c('b-row',[_c('b-col',{attrs:{"offset-md":"1","md":"10"}},[_c('CapsuleContent',{attrs:{"capsule":_vm.capsule,"stitch-mode":false}})],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c78b7994","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/capsuleBuilder/modals/OutfitsModal.vue
// module id = 4oc8
// module chunks = 0